export const pipeline_tree = [
  {
    name: "building_permit",
    id: 1,
    label: "Building Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "awning",
            id: 66,
            label: "Awning",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "business_condo",
            id: 58,
            label: "Business Condo",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "canopies",
            id: 67,
            label: "Canopies",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "cell_tower",
            id: 64,
            label: "Cell Tower",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "masonry_wall",
            id: 62,
            label: "Masonry Wall",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "playground_equipment",
            id: 65,
            label: "Playground Equipment",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "pylon",
            id: 60,
            label: "Pylon",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "retaining_wall",
            id: 63,
            label: "Retaining Wall",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "sewage_treatment_plant",
            id: 73,
            label: "Sewage Treatment Plant",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "storage_tank_foundation",
            id: 61,
            label: "Storage Tank Foundation",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "tents",
            id: 68,
            label: "Tents",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "water_tower",
            id: 59,
            label: "Water Tower",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "accessory_dwelling_unit",
                id: 55,
                label: "Accessory Dwelling Unit",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_dwelling_unit_-_attached",
                id: 56,
                label: "Accessory Dwelling Unit - Attached",
                field_bind: "WorkTypeId",
              },
              {
                name: "accessory_structure",
                id: 1,
                label: "Accessory Structure",
                field_bind: "WorkTypeId",
              },
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
              },
              {
                name: "alterations_&_repairs",
                id: 4,
                label: "Alterations & Repairs",
                field_bind: "WorkTypeId",
              },
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "converting_use",
                id: 5,
                label: "Converting Use",
                field_bind: "WorkTypeId",
              },
              {
                name: "demolition",
                id: 6,
                label: "Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "foundation_only",
                id: 9,
                label: "Foundation Only",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_into_duval",
                id: 15,
                label: "Move Bldg Into Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_out_of_duval",
                id: 16,
                label: "Move Bldg Out Of Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "move_bldg_within_duval",
                id: 17,
                label: "Move Bldg Within Duval",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "shell_building",
                id: 26,
                label: "Shell Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "siding_installation/repair",
                id: 19,
                label: "Siding Installation/Repair",
                field_bind: "WorkTypeId",
              },
              {
                name: "small_cell",
                id: 42,
                label: "Small Cell",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
              },
              {
                name: "swimming_pool_demolition",
                id: 57,
                label: "Swimming Pool Demolition",
                field_bind: "WorkTypeId",
              },
              {
                name: "window/door_replacement",
                id: 39,
                label: "Window/Door Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "electrical_permit",
    id: 3,
    label: "Electrical Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "accessory",
            id: 56,
            label: "Accessory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "commercial_addition",
                    id: 80,
                    label: "Commercial Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "mobile_homes",
            id: 24,
            label: "Mobile Homes",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fire_repair",
                    id: 38,
                    label: "Fire Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "mh_subfeed",
                    id: 33,
                    label: "MH Subfeed",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "room_addition",
                    id: 31,
                    label: "Room Addition",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "spec_build-out",
                    id: 56,
                    label: "Spec build-out",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "un-metered_main",
                    id: 76,
                    label: "Un-Metered Main",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "sign",
                id: 27,
                label: "Sign",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rewire",
                    id: 30,
                    label: "Rewire",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "swimming_pool",
                id: 29,
                label: "Swimming Pool",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "above_ground_pool",
                    id: 78,
                    label: "Above Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "in-ground_pool",
                    id: 77,
                    label: "In-Ground Pool",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "low_voltage",
                    id: 74,
                    label: "Low Voltage",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "temporary_pole",
                id: 21,
                label: "Temporary Pole",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "overhead_temp_pole",
                    id: 72,
                    label: "Overhead Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair_-_no_inspections",
                    id: 75,
                    label: "Repair - No Inspections",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "safety",
                    id: 32,
                    label: "Safety",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "u_g_temp_service_pole",
                    id: 71,
                    label: "U G Temp Service Pole",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "underground_temp_pole",
                    id: 70,
                    label: "UnderGround Temp Pole",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "fire_permit",
    id: 9,
    label: "Fire Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "accessory",
            id: 56,
            label: "Accessory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "mobile_homes",
            id: 24,
            label: "Mobile Homes",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
              },
              {
                name: "tenant_build-out",
                id: 30,
                label: "Tenant Build-Out",
                field_bind: "WorkTypeId",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "mechanical_permit",
    id: 2,
    label: "Mechanical Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "accessory",
            id: 56,
            label: "Accessory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "mobile_homes",
            id: 24,
            label: "Mobile Homes",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "extension_or_add-on_to_existing_system",
                    id: 49,
                    label: "Extension or Add-On to Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_installation",
                    id: 28,
                    label: "New Installation",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "replacment_of_existing_system",
                    id: 27,
                    label: "Replacment of Existing System",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "mobile_home_permit",
    id: 6,
    label: "Mobile Home Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "mobile_homes",
            id: 24,
            label: "Mobile Homes",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "mobile_home_-_new",
                id: 13,
                label: "Mobile Home - New",
                field_bind: "WorkTypeId",
              },
              {
                name: "mobile_home_-_replacement",
                id: 14,
                label: "Mobile Home - Replacement",
                field_bind: "WorkTypeId",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "plumbing_permit",
    id: 4,
    label: "Plumbing Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "accessory",
            id: 56,
            label: "Accessory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "mobile_homes",
            id: 24,
            label: "Mobile Homes",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "fixture_replacement",
                    id: 68,
                    label: "Fixture Replacement",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "relining_sewer/drain",
                    id: 81,
                    label: "Relining Sewer/Drain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "repair",
                    id: 36,
                    label: "Repair",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sanitary_redrain",
                    id: 82,
                    label: "Sanitary Redrain",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_disconnect",
                    id: 44,
                    label: "Sewer Disconnect",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_repipe",
                    id: 41,
                    label: "Water Repipe",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "lawn_sprinklers",
                    id: 47,
                    label: "Lawn Sprinklers",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_fixtures(s)",
                    id: 69,
                    label: "New Fixtures(s)",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "rough-in_only",
                    id: 42,
                    label: "Rough-In Only",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "sewer_connection",
                    id: 67,
                    label: "Sewer Connection",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "solar-heat_recovery_units",
                    id: 48,
                    label: "Solar-Heat Recovery Units",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "water_service",
                    id: 43,
                    label: "Water Service",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "right_of_way_permit",
    id: 10,
    label: "Right Of Way Permit",
    field_bind: "PermitTypeId",
    proposed_use: [],
  },
  {
    name: "roofing_permit",
    id: 8,
    label: "Roofing Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "accessory",
            id: 56,
            label: "Accessory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "carports",
            id: 20,
            label: "Carports",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "garages",
            id: 22,
            label: "Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "addition",
                id: 2,
                label: "Addition",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "existing_building",
                id: 7,
                label: "Existing Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_over_existing",
                    id: 73,
                    label: "Roof Over Existing",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "mobile_home",
                id: 12,
                label: "Mobile Home",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
              {
                name: "new_building",
                id: 18,
                label: "New Building",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new_roof",
                    id: 63,
                    label: "New roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "re-roof",
                    id: 61,
                    label: "Re-roof",
                    field_bind: "WorkSubTypeId",
                  },
                  {
                    name: "roof_repair",
                    id: 62,
                    label: "Roof repair",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "sign_permit",
    id: 5,
    label: "Sign Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "off-site",
        id: 4,
        label: "Off-Site",
        field_bind: "ProposedUseId",
        work_type: [
          {
            name: "city_sign",
            id: 45,
            label: "City Sign",
            field_bind: "WorkTypeId",
          },
          {
            name: "new_sign",
            id: 52,
            label: "New Sign",
            field_bind: "WorkTypeId",
          },
          {
            name: "rebuild",
            id: 47,
            label: "Rebuild",
            field_bind: "WorkTypeId",
          },
          {
            name: "relocate",
            id: 48,
            label: "Relocate",
            field_bind: "WorkTypeId",
          },
          {
            name: "removal",
            id: 49,
            label: "Removal",
            field_bind: "WorkTypeId",
          },
          {
            name: "repair/maintenance",
            id: 50,
            label: "Repair/Maintenance",
            field_bind: "WorkTypeId",
          },
        ],
      },
      {
        name: "on-site",
        id: 5,
        label: "On-Site",
        field_bind: "ProposedUseId",
        work_type: [
          {
            name: "new_sign",
            id: 52,
            label: "New Sign",
            field_bind: "WorkTypeId",
          },
          {
            name: "removal",
            id: 49,
            label: "Removal",
            field_bind: "WorkTypeId",
          },
          {
            name: "temporary",
            id: 51,
            label: "Temporary",
            field_bind: "WorkTypeId",
          },
        ],
      },
    ],
  },
  {
    name: "sitework_permit",
    id: 7,
    label: "SiteWork Permit",
    field_bind: "PermitTypeId",
    proposed_use: [
      {
        name: "non-residential",
        id: 2,
        label: "Non-Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "agriculture",
            id: 70,
            label: "Agriculture",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "assembly",
            id: 1,
            label: "Assembly",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "business,_office,_bank,_professional",
            id: 9,
            label: "Business, Office, Bank, Professional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "church,_other_religious",
            id: 2,
            label: "Church, Other Religious",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "convert_residence",
            id: 3,
            label: "Convert Residence",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "daycare",
            id: 54,
            label: "Daycare",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hospital,_institutional",
            id: 5,
            label: "Hospital, Institutional",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "hotel,motel,dormitory",
            id: 6,
            label: "Hotel,Motel,Dormitory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "industrial,_factory",
            id: 7,
            label: "Industrial, Factory",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "parking_garages",
            id: 11,
            label: "Parking Garages",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "restaurants",
            id: 12,
            label: "Restaurants",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "school,_library,_other_educational",
            id: 13,
            label: "School, Library, Other Educational",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "service_station,_repair_garage",
            id: 14,
            label: "Service Station, Repair Garage",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "storage_warehouse",
            id: 75,
            label: "Storage Warehouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "stores,_mercantile",
            id: 15,
            label: "Stores, Mercantile",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "utilities",
            id: 18,
            label: "Utilities",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: "residential",
        id: 1,
        label: "Residential",
        field_bind: "ProposedUseId",
        structure_type: [
          {
            name: "3_or_4_families",
            id: 27,
            label: "3 Or 4 Families",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "agricultural",
            id: 57,
            label: "Agricultural",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "apartments",
            id: 19,
            label: "Apartments",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "care_facility",
            id: 74,
            label: "Care Facility",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "condominiums",
            id: 21,
            label: "Condominiums",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "duplex/two-family",
            id: 29,
            label: "Duplex/Two-Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family",
            id: 26,
            label: "Single Family",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "single_family_subdivision",
            id: 52,
            label: "Single Family Subdivision",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
          {
            name: "townhouse",
            id: 53,
            label: "Townhouse",
            field_bind: "StructureTypeId",
            work_type: [
              {
                name: "borrow_pit",
                id: 38,
                label: "Borrow Pit",
                field_bind: "WorkTypeId",
              },
              {
                name: "fill(sfha)",
                id: 41,
                label: "Fill(SFHA)",
                field_bind: "WorkTypeId",
              },
              {
                name: "horizontal_development_(not_vertical)",
                id: 11,
                label: "Horizontal Development (Not Vertical)",
                field_bind: "WorkTypeId",
              },
              {
                name: "pine_harvest",
                id: 22,
                label: "Pine Harvest",
                field_bind: "WorkTypeId",
              },
              {
                name: "pond",
                id: 23,
                label: "Pond",
                field_bind: "WorkTypeId",
              },
              {
                name: "site_clearing_(through_vertical_construction)",
                id: 28,
                label: "Site Clearing (Through Vertical Construction)",
                field_bind: "WorkTypeId",
              },
              {
                name: "tree_removal",
                id: 32,
                label: "Tree Removal",
                field_bind: "WorkTypeId",
              },
              {
                name: "under_brushing",
                id: 37,
                label: "Under Brushing",
                field_bind: "WorkTypeId",
                work_sub_type: [
                  {
                    name: "new",
                    id: 54,
                    label: "New",
                    field_bind: "WorkSubTypeId",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
